import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../../api/api_client';

export const defaultWinnerState = {
    winners: {},
    error: '',
};

export const winnerSlice = createSlice({
    name: 'winner',
    initialState: defaultWinnerState,
    reducers: {
        getWinners: (
            state,
            {
                payload: {
                    requested: { category, draw_number },
                    drawings = [],
                },
            }
        ) => {
            const newWinners = {
                ...state.winners,
            };

            drawings.forEach(draw => {
                newWinners[`${category}-${draw_number}`] = draw;
            });

            if (newWinners[`${category}-${draw_number}`].loading) {
                // Something went wrong and we didn't receive the expected data,
                // just clear the object along with its loading flag.
                // *NOTE* the category and draw_number here are from the payload
                // not the response
                delete newWinners[`${category}-${draw_number}`];
            }

            return {
                ...state,
                winners: newWinners,
            };
        },
        setLoading: (
            state,
            { payload: { draw_number, category, loading = true } }
        ) => {
            return {
                ...state,
                winners: {
                    ...state.winners,
                    [`${category}-${draw_number}`]: {
                        ...(state.winners[`${category}-${draw_number}`] || {}),
                        loading: loading,
                    },
                },
            };
        },
        reset: (state, action) => {
            return {
                ...defaultWinnerState,
            };
        },
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary
const getWinners = async (
    dispatch,
    { game_id, category, draw_date, draw_number }
) => {
    dispatch(winnerSlice.actions.setLoading({ category, draw_number }));
    try {
        const result = await apiClient.getWinners({
            game_id,
            category,
            draw_date,
            draw_number,
        });
        dispatch(winnerSlice.actions.getWinners(result));
    } catch (e) {
        dispatch(
            winnerSlice.actions.setLoading({
                category,
                draw_date,
                loading: false,
            })
        );
    }
};

//actions that get exported to the views
export const winnerActions = dispatch => {
    return {
        getWinners: payload => getWinners(dispatch, payload),
        reset: payload => dispatch(winnerSlice.actions.reset(payload)),
    };
};
